import styled from 'styled-components';

const StyledVendorsTabs = styled.div`
  display: flex;
  justify-content: center;
  overflow-x: hidden;
  padding: 24px;
  position: relative;

  .ant-tabs-tabpane {
    & > div {
      padding: 0;
    }
  }
`;

export {
  StyledVendorsTabs,
}
